import classes from './Notification.module.css';
import React, {useEffect, useState} from "react";
import {authAxios} from "../../../API/apiRequest";
import {Loading} from "../../../components/Loading/Loading";
import {FiClock} from "react-icons/fi";
import TimeAgo from "javascript-time-ago";
import styled from "styled-components";
import {ModalSubmit} from "../Submissions/ModalSubmit";
import {Button} from "../../../components/Button/Button";
import {NoData} from "../../../components/NoData/NoData";

const Time = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
const TimeText = styled.p`
  font-size: 11px;
  color: #BBBBBB;
  padding: 0;
  margin: 0;
  margin-left: 5px;
`
export const Notification: React.FC = () => {
    const timeAgo = new TimeAgo('ar-EG')
    const [page, setpage] = useState<number>(1)
    const [Notifications, setNotifications] = useState<{
        hasNext: boolean,
        lastPage: number,
        nextPage: number,
        notifications: {
            body: string,
            createdAt: string,
            data: {
                id: string,
                type: string,
            }

            id: string,
            title: string
        } [],
        total: number
    }>()
    const [Load, setLoad] = useState<boolean>(true);
    const [nodata, setnodata] = useState<boolean>(false);
    useEffect(() => {
        authAxios.get(`/employee/notification`).then((res) => {
            if(res.status === 200 && res.data.notifications.length > 0) {
                setNotifications(res.data)
                setLoad(false)
            } else {
                setLoad(false)
                setnodata(true)
            }
        }).catch(err => {
            console.log(err)
        })
    }, [])
    const [Jop, setJop]: any = useState<{
                appointment: string,
                createdAt: string,
                companyId: string,
                companyImage: string,
                companyName: string,
                form: Array<{
                    question: string, answer: string
                }>,
                id: string,
                jobId: string,
                jobName: string,
                status: string,
                updatedAt: string,
            }>(),
            [Open, setOpen] = useState(false),
            [ModalLoad, setModalLoad] = useState<boolean>(true);
    const HandleOpenModal: any = (data: any) => {
        console.log(data)
        setOpen(true);
        setModalLoad(true);
        authAxios.get(`/employee/applications/${data}`).then((res) => {
            if(res.status === 200) {
                setModalLoad(false);
                setJop(res.data.application);
                setLoad(false);
            }
        }).catch(err => {
            console.log(err)
        })
    }
    return (<>

        <div id={'Notification'}
             className={classes.notificationCard + '  rtl animate__animated    animate__fadeIn '}>
            {Notifications && Notifications.notifications.length > 0 && !Load ? (
                    <div className={'w-100 d-flex flex-column p-3   ' + classes.notiCard}>
                        {Notifications && Notifications.notifications.map(noti => {
                            return (<div key={noti.id} className={classes.noti}
                                         onClick={() => HandleOpenModal(noti.data.id)}>
                                <p className={classes.title}>{noti.title}</p>
                                <p className={classes.body}>{noti.body}</p>
                                <div className={'d-flex justify-content-end'}>

                                    <Time>
                                        <FiClock color='#BBBBBB' size={19} style={{marginLeft: 8}}/>
                                        <TimeText>منذ {(timeAgo.format(Date.now() - (Date.now() - new Date(noti.createdAt).getTime()))).toString().replace("قبل", '')}</TimeText>
                                    </Time>
                                </div>

                            </div>);
                        })}
                        <div className={'w-100 d-flex justify-content-center'}>
                            <div className={"mt-2 d-flex"}>
                                <Button width={100} height={38}
                                        disabled={!(Notifications && Notifications.hasNext)}
                                        onPress={() => {
                                            if(Notifications && Notifications.hasNext) {
                                                let num = page;
                                                num++;
                                                setpage(num);
                                            }
                                        }}
                                        color='black'>التالي</Button>

                                <Button width={100} height={38}


                                        disabled={page <= 1}
                                        onPress={() => {
                                            if(page > 1) {
                                                let num = page;
                                                num--;
                                                setpage(num);
                                            }
                                        }}
                                        color='black'>السابق</Button>

                            </div>
                        </div>

                    </div>) : Load ? (<Loading width={200} smhight></Loading>) : nodata ? (
                    <div className={'py-4'}><NoData nobackground width={150}/></div>) : ""}
        </div>

        <ModalSubmit Open={Open} ModalLoad={ModalLoad} setOpen={setOpen} Jop={Jop}/>
    </>)
}
